<!-- src/components/Pages/OIDCCallback.vue -->
<template>
  <div style="padding:24px;font-family:system-ui,Arial">
    <h2>Autenticando…</h2>
    <p>{{ status }}</p>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import userManager from "../../services/oidcUserManager";

const status = ref("Processando retorno do provedor…");
const router = useRouter();

const getRedirectPath = (user) => {
  const redirect = user?.state?.redirectPath;
  return typeof redirect === "string" && redirect.startsWith("/") && !redirect.startsWith("//")
    ? redirect
    : "/dashboard";
};

onMounted(async () => {
  try {
    await userManager.signinRedirectCallback();
    const user = await userManager.getUser();
    if (user && !user.expired) {
      status.value = "Autenticado! Redirecionando…";
      router.replace(getRedirectPath(user));
      return;
    }
    throw new Error("Sessão inválida ou expirada.");
  } catch (e) {
    ElMessage.error("Falha na autenticação: " + (e?.message || e));
    window.location.replace("/login");
  }
});
</script>
